import { all, fork } from 'redux-saga/effects';

import deleteMultiplePhysicianSagas from './delete-multiple-physician/sagas';
import downsellReasonSagas from './downsell-reason/sagas';

export default function* freeSamplesSagas() {
  yield all([fork(downsellReasonSagas), fork(deleteMultiplePhysicianSagas)]);
}
